const messages = {
  title: "Liste de prețuri și broșuri de produse",
  description:
    "Descărcați aici cele mai recente broșuri și flyere despre anvelopele Bridgestone și Firestone pentru autoturisme, SUV-uri și autoutilitare.",
  brochureCategories: {
    products: "Produse",
    brand_and_solutions: "Marcă și soluții",
    season_and_promotions: "Sezon și promoții",
    format: "Format",
    cars_and_vans: "Autoturism, SUV, utilitar",
    summer: "Vara",
    winter: "Iarna",
    promotions: "Promoții",
    all_season: "Toate anotimpurile",
    truck_and_buses: "Camion și autobuz",
    motorcycle: "Motocicletă",
    agriculture: "Agricultură",
    construction_machinery: "Utilaje de construcții",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiale",
    brochures: "Broșuri de produs",
    price_list: "Liste de prețuri",
    materials: "Materiale",
    video_in_store: "Video cu subtitrări",
    video_online: "Video fără subtitrări",
    banner_website: "Banner",
    banner_social_media: "Rețele sociale",
    logos: "Logo-uri",
  },
  searchMedia: "Introduceți un cuvânt cheie",
  searchResults: "Rezultatele căutării",
};

export default {
  messages,
};
